import { useEffect, useRef, useState } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import JobCardsSection from './components/JobCardsSection';
import TrustSection from './components/TrustSection';
import FormModal from './components/FormModal';
import { setupTapTracking, setupViewTracking } from './utils/tracking';
import { initPageTracking } from './utils/formUtils';
import { BG_WARM, BG_SECTION } from './utils/theme';

export default function Home() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const jobsSectionRef = useRef<HTMLDivElement>(null);
  const trackingInitialized = useRef(false);

  useEffect(() => {
    // ページ表示時: visitor_id 生成 + UTM/affiliate を sessionStorage に保存
    initPageTracking();

    if (trackingInitialized.current) return;
    trackingInitialized.current = true;
    const t = setTimeout(() => {
      setupViewTracking();
      setupTapTracking();
    }, 500);
    return () => clearTimeout(t);
  }, []);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const handleScrollToJobs = () => {
    jobsSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div style={{ background: BG_WARM, minHeight: '100dvh' }}>
      {/* Center wrapper for desktop */}
      <div
        style={{
          maxWidth: 430,
          margin: '0 auto',
          position: 'relative',
          minHeight: '100dvh',
          boxShadow: '0 0 40px rgba(0,0,0,0.06)',
          background: BG_WARM,
        }}
      >
        {/* Header */}
        <Header />

        {/* First View */}
        <HeroSection
          onOpenModal={handleOpenModal}
          onScrollToJobs={handleScrollToJobs}
        />

        {/* Job Card Swipe – FV直下 */}
        <div ref={jobsSectionRef}>
          <JobCardsSection onOpenModal={handleOpenModal} />
        </div>

        {/* Trust & Reassurance section */}
        <TrustSection onOpenModal={handleOpenModal} />

        {/* Footer */}
        <footer
          style={{
            padding: '24px 20px 40px',
            textAlign: 'center',
            borderTop: '1px solid #FFD6E8',
            background: BG_SECTION,
          }}
        >
          {/* Footer navigation links */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: 20,
              flexWrap: 'wrap',
              marginBottom: 16,
            }}
          >
            <a
              href="https://nijikango.co.jp/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontSize: 11,
                color: '#c0536a',
                textDecoration: 'none',
                fontWeight: 600,
                whiteSpace: 'nowrap',
              }}
            >
              運営会社
            </a>
            <span style={{ fontSize: 11, color: '#ddd' }}>|</span>
            <a
              href="https://lp.nijikango.co.jp/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontSize: 11,
                color: '#c0536a',
                textDecoration: 'none',
                fontWeight: 600,
                whiteSpace: 'nowrap',
              }}
            >
              プライバシーポリシー
            </a>
            <span style={{ fontSize: 11, color: '#ddd' }}>|</span>
            <a
              href="https://lp.nijikango.co.jp/terms-of-service"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontSize: 11,
                color: '#c0536a',
                textDecoration: 'none',
                fontWeight: 600,
                whiteSpace: 'nowrap',
              }}
            >
              利用規約
            </a>
          </div>

          <p style={{ fontSize: 10, color: '#bbb', lineHeight: 1.8 }}>
            ニジ看護転職<br />
            厚生労働大臣許可番号：13-ユ-317878<br />
            &copy; 2026 ニジ看護転職 All Rights Reserved.
          </p>
        </footer>
      </div>

      {/* Modal Form */}
      <FormModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </div>
  );
}
